var _excluded = ["id"],
    _excluded2 = ["id", "tabIndex"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Fragment as z, computed as c, defineComponent as D, h as H, inject as A, onMounted as M, onUnmounted as K, provide as N, ref as g, watchEffect as _, watch as J } from "vue";
import { Features as $, render as O, omit as Q } from '../../utils/render.js';
import { useId as q } from '../../hooks/use-id.js';
import { Keys as x } from '../../keyboard.js';
import { dom as d } from '../../utils/dom.js';
import { match as C } from '../../utils/match.js';
import { focusIn as P, Focus as I, FocusResult as F, sortByDomNode as L } from '../../utils/focus-management.js';
import { useResolveButtonType as V } from '../../hooks/use-resolve-button-type.js';
import { FocusSentinel as X } from '../../internal/focus-sentinel.js';
import { microTask as Y } from '../../utils/micro-task.js';
import { Hidden as Z } from '../../internal/hidden.js';
import { getOwnerDocument as ee } from '../../utils/owner.js';

var te = function (i) {
  return i[i.Forwards = 0] = "Forwards", i[i.Backwards = 1] = "Backwards", i;
}(te || {}),
    le = function (s) {
  return s[s.Less = -1] = "Less", s[s.Equal = 0] = "Equal", s[s.Greater = 1] = "Greater", s;
}(le || {});

var U = Symbol("TabsContext");

function k(a) {
  var v = A(U, null);

  if (v === null) {
    var i = new Error("<".concat(a, " /> is missing a parent <TabGroup /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(i, k), i;
  }

  return v;
}

var j = Symbol("TabsSSRContext"),
    xe = D({
  name: "TabGroup",
  emits: {
    change: function change(a) {
      return !0;
    }
  },
  props: {
    as: {
      type: [Object, String],
      default: "template"
    },
    selectedIndex: {
      type: [Number],
      default: null
    },
    defaultIndex: {
      type: [Number],
      default: 0
    },
    vertical: {
      type: [Boolean],
      default: !1
    },
    manual: {
      type: [Boolean],
      default: !1
    }
  },
  inheritAttrs: !1,
  setup: function setup(a, _ref) {
    var v = _ref.slots,
        i = _ref.attrs,
        s = _ref.emit;
    var h;
    var l = g((h = a.selectedIndex) != null ? h : a.defaultIndex),
        n = g([]),
        o = g([]),
        T = c(function () {
      return a.selectedIndex !== null;
    }),
        b = c(function () {
      return T.value ? a.selectedIndex : l.value;
    });

    function m(t) {
      var S;
      var e = L(r.tabs.value, d),
          u = L(r.panels.value, d),
          f = e.filter(function (p) {
        var E;
        return !((E = d(p)) != null && E.hasAttribute("disabled"));
      });

      if (t < 0 || t > e.length - 1) {
        var _C2, _C3;

        var p = C(l.value === null ? 0 : Math.sign(t - l.value), (_C2 = {}, _defineProperty(_C2, -1, function () {
          return 1;
        }), _defineProperty(_C2, 0, function _() {
          var _C;

          return C(Math.sign(t), (_C = {}, _defineProperty(_C, -1, function () {
            return 0;
          }), _defineProperty(_C, 0, function _() {
            return 0;
          }), _defineProperty(_C, 1, function _() {
            return 1;
          }), _C));
        }), _defineProperty(_C2, 1, function _() {
          return 0;
        }), _C2));
        l.value = C(p, (_C3 = {}, _defineProperty(_C3, 0, function _() {
          return e.indexOf(f[0]);
        }), _defineProperty(_C3, 1, function _() {
          return e.indexOf(f[f.length - 1]);
        }), _C3)), r.tabs.value = e, r.panels.value = u;
      } else {
        var _p = e.slice(0, t),
            G = [].concat(_toConsumableArray(e.slice(t)), _toConsumableArray(_p)).find(function (W) {
          return f.includes(W);
        });

        if (!G) return;
        var B = (S = e.indexOf(G)) != null ? S : r.selectedIndex.value;
        B === -1 && (B = r.selectedIndex.value), l.value = B, r.tabs.value = e, r.panels.value = u;
      }
    }

    var r = {
      selectedIndex: c(function () {
        var t, e;
        return (e = (t = l.value) != null ? t : a.defaultIndex) != null ? e : null;
      }),
      orientation: c(function () {
        return a.vertical ? "vertical" : "horizontal";
      }),
      activation: c(function () {
        return a.manual ? "manual" : "auto";
      }),
      tabs: n,
      panels: o,
      setSelectedIndex: function setSelectedIndex(t) {
        b.value !== t && s("change", t), T.value || m(t);
      },
      registerTab: function registerTab(t) {
        var f;
        if (n.value.includes(t)) return;
        var e = n.value[l.value];
        n.value.push(t), n.value = L(n.value, d);
        var u = (f = n.value.indexOf(e)) != null ? f : l.value;
        u !== -1 && (l.value = u);
      },
      unregisterTab: function unregisterTab(t) {
        var e = n.value.indexOf(t);
        e !== -1 && n.value.splice(e, 1);
      },
      registerPanel: function registerPanel(t) {
        o.value.includes(t) || (o.value.push(t), o.value = L(o.value, d));
      },
      unregisterPanel: function unregisterPanel(t) {
        var e = o.value.indexOf(t);
        e !== -1 && o.value.splice(e, 1);
      }
    };
    N(U, r);
    var R = g({
      tabs: [],
      panels: []
    }),
        y = g(!1);
    M(function () {
      y.value = !0;
    }), N(j, c(function () {
      return y.value ? null : R.value;
    }));
    var w = c(function () {
      return a.selectedIndex;
    });
    return M(function () {
      J([w], function () {
        var t;
        return m((t = a.selectedIndex) != null ? t : a.defaultIndex);
      }, {
        immediate: !0
      });
    }), _(function () {
      if (!T.value || b.value == null || r.tabs.value.length <= 0) return;
      var t = L(r.tabs.value, d);
      t.some(function (u, f) {
        return d(r.tabs.value[f]) !== d(u);
      }) && r.setSelectedIndex(t.findIndex(function (u) {
        return d(u) === d(r.tabs.value[b.value]);
      }));
    }), function () {
      var t = {
        selectedIndex: l.value
      };
      return H(z, [n.value.length <= 0 && H(X, {
        onFocus: function onFocus() {
          var _iterator = _createForOfIteratorHelper(n.value),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var e = _step.value;
              var u = d(e);
              if ((u == null ? void 0 : u.tabIndex) === 0) return u.focus(), !0;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          return !1;
        }
      }), O({
        theirProps: _objectSpread(_objectSpread({}, i), Q(a, ["selectedIndex", "defaultIndex", "manual", "vertical", "onChange"])),
        ourProps: {},
        slot: t,
        slots: v,
        attrs: i,
        name: "TabGroup"
      })]);
    };
  }
}),
    Ie = D({
  name: "TabList",
  props: {
    as: {
      type: [Object, String],
      default: "div"
    }
  },
  setup: function setup(a, _ref2) {
    var v = _ref2.attrs,
        i = _ref2.slots;
    var s = k("TabList");
    return function () {
      var l = {
        selectedIndex: s.selectedIndex.value
      },
          n = {
        role: "tablist",
        "aria-orientation": s.orientation.value
      };
      return O({
        ourProps: n,
        theirProps: a,
        slot: l,
        attrs: v,
        slots: i,
        name: "TabList"
      });
    };
  }
}),
    ye = D({
  name: "Tab",
  props: {
    as: {
      type: [Object, String],
      default: "button"
    },
    disabled: {
      type: [Boolean],
      default: !1
    },
    id: {
      type: String,
      default: function _default() {
        return "headlessui-tabs-tab-".concat(q());
      }
    }
  },
  setup: function setup(a, _ref3) {
    var v = _ref3.attrs,
        i = _ref3.slots,
        s = _ref3.expose;
    var l = k("Tab"),
        n = g(null);
    s({
      el: n,
      $el: n
    }), M(function () {
      return l.registerTab(n);
    }), K(function () {
      return l.unregisterTab(n);
    });
    var o = A(j),
        T = c(function () {
      if (o.value) {
        var e = o.value.tabs.indexOf(a.id);
        return e === -1 ? o.value.tabs.push(a.id) - 1 : e;
      }

      return -1;
    }),
        b = c(function () {
      var e = l.tabs.value.indexOf(n);
      return e === -1 ? T.value : e;
    }),
        m = c(function () {
      return b.value === l.selectedIndex.value;
    });

    function r(e) {
      var f;
      var u = e();

      if (u === F.Success && l.activation.value === "auto") {
        var S = (f = ee(n)) == null ? void 0 : f.activeElement,
            p = l.tabs.value.findIndex(function (E) {
          return d(E) === S;
        });
        p !== -1 && l.setSelectedIndex(p);
      }

      return u;
    }

    function R(e) {
      var u = l.tabs.value.map(function (S) {
        return d(S);
      }).filter(Boolean);

      if (e.key === x.Space || e.key === x.Enter) {
        e.preventDefault(), e.stopPropagation(), l.setSelectedIndex(b.value);
        return;
      }

      switch (e.key) {
        case x.Home:
        case x.PageUp:
          return e.preventDefault(), e.stopPropagation(), r(function () {
            return P(u, I.First);
          });

        case x.End:
        case x.PageDown:
          return e.preventDefault(), e.stopPropagation(), r(function () {
            return P(u, I.Last);
          });
      }

      if (r(function () {
        return C(l.orientation.value, {
          vertical: function vertical() {
            return e.key === x.ArrowUp ? P(u, I.Previous | I.WrapAround) : e.key === x.ArrowDown ? P(u, I.Next | I.WrapAround) : F.Error;
          },
          horizontal: function horizontal() {
            return e.key === x.ArrowLeft ? P(u, I.Previous | I.WrapAround) : e.key === x.ArrowRight ? P(u, I.Next | I.WrapAround) : F.Error;
          }
        });
      }) === F.Success) return e.preventDefault();
    }

    var y = g(!1);

    function w() {
      var e;
      y.value || (y.value = !0, !a.disabled && ((e = d(n)) == null || e.focus(), l.setSelectedIndex(b.value), Y(function () {
        y.value = !1;
      })));
    }

    function h(e) {
      e.preventDefault();
    }

    var t = V(c(function () {
      return {
        as: a.as,
        type: v.type
      };
    }), n);
    return function () {
      var p;

      var e = {
        selected: m.value
      },
          u = a.id,
          f = _objectWithoutProperties(a, _excluded),
          S = {
        ref: n,
        onKeydown: R,
        onMousedown: h,
        onClick: w,
        id: u,
        role: "tab",
        type: t.value,
        "aria-controls": (p = d(l.panels.value[b.value])) == null ? void 0 : p.id,
        "aria-selected": m.value,
        tabIndex: m.value ? 0 : -1,
        disabled: a.disabled ? !0 : void 0
      };

      return O({
        ourProps: S,
        theirProps: f,
        slot: e,
        attrs: v,
        slots: i,
        name: "Tab"
      });
    };
  }
}),
    Se = D({
  name: "TabPanels",
  props: {
    as: {
      type: [Object, String],
      default: "div"
    }
  },
  setup: function setup(a, _ref4) {
    var v = _ref4.slots,
        i = _ref4.attrs;
    var s = k("TabPanels");
    return function () {
      var l = {
        selectedIndex: s.selectedIndex.value
      };
      return O({
        theirProps: a,
        ourProps: {},
        slot: l,
        attrs: i,
        slots: v,
        name: "TabPanels"
      });
    };
  }
}),
    ge = D({
  name: "TabPanel",
  props: {
    as: {
      type: [Object, String],
      default: "div"
    },
    static: {
      type: Boolean,
      default: !1
    },
    unmount: {
      type: Boolean,
      default: !0
    },
    id: {
      type: String,
      default: function _default() {
        return "headlessui-tabs-panel-".concat(q());
      }
    },
    tabIndex: {
      type: Number,
      default: 0
    }
  },
  setup: function setup(a, _ref5) {
    var v = _ref5.attrs,
        i = _ref5.slots,
        s = _ref5.expose;
    var l = k("TabPanel"),
        n = g(null);
    s({
      el: n,
      $el: n
    }), M(function () {
      return l.registerPanel(n);
    }), K(function () {
      return l.unregisterPanel(n);
    });
    var o = A(j),
        T = c(function () {
      if (o.value) {
        var r = o.value.panels.indexOf(a.id);
        return r === -1 ? o.value.panels.push(a.id) - 1 : r;
      }

      return -1;
    }),
        b = c(function () {
      var r = l.panels.value.indexOf(n);
      return r === -1 ? T.value : r;
    }),
        m = c(function () {
      return b.value === l.selectedIndex.value;
    });
    return function () {
      var t;

      var r = {
        selected: m.value
      },
          R = a.id,
          y = a.tabIndex,
          w = _objectWithoutProperties(a, _excluded2),
          h = {
        ref: n,
        id: R,
        role: "tabpanel",
        "aria-labelledby": (t = d(l.tabs.value[b.value])) == null ? void 0 : t.id,
        tabIndex: m.value ? y : -1
      };

      return !m.value && a.unmount && !a.static ? H(Z, _objectSpread({
        as: "span"
      }, h)) : O({
        ourProps: h,
        theirProps: w,
        slot: r,
        attrs: v,
        slots: i,
        features: $.Static | $.RenderStrategy,
        visible: m.value,
        name: "TabPanel"
      });
    };
  }
});
export { ye as Tab, xe as TabGroup, Ie as TabList, ge as TabPanel, Se as TabPanels };